/**
 * Best-effort parser for HookHouse's `# Title // Artist` + `## Summary` + `## Lyrics`
 * markdown shape used to shuttle song data between tabs (Studio output, RiffWriter
 * seeds → Art tab / album cover concept generators).
 */

export interface SongMarkdown {
  title: string;
  artist: string;
  summary: string;
  lyrics: string;
}

export function parseSongMarkdown(md: string): SongMarkdown {
  if (!md.trim()) return { title: '', artist: '', summary: '', lyrics: '' };

  const headerMatch = md.match(/^#\s+(.+?)(?:\s+\/\/\s+(.+))?\s*$/m);
  const title = headerMatch?.[1]?.trim() ?? '';
  const artist = headerMatch?.[2]?.trim() ?? '';

  const sectionBody = (name: string): string => {
    const re = new RegExp(`##\\s+${name}\\s*\\n([\\s\\S]*?)(?=\\n##\\s+|$)`, 'i');
    const m = md.match(re);
    if (!m) return '';
    return m[1]
      .replace(/```[a-z]*\n?/gi, '')
      .replace(/```/g, '')
      .trim();
  };

  return {
    title,
    artist,
    summary: sectionBody('Summary'),
    lyrics: sectionBody('Lyrics'),
  };
}
